import { STOCK_TYPES } from "../enums/StockTypes";
import { STOCK_AVAILABILITY_MODES } from "../enums/StockAvailabilityModes";
import { hasValue } from "../utils/NumberUtils";

const cleanStockDay = ({ customMorfySplit, ...day }) => {
  const { quantity, percentage } = customMorfySplit ?? {};

  if (!hasValue(quantity) || !hasValue(percentage)) return day;

  return { ...day, customMorfySplit: { quantity, percentage } };
};

export const transformProduct = (data) => {
  const {
    stockAvailability,
    stockDaysFrom,
    stockDaysTo,
    stockDaysBulkQuantity,
    stockDaysBulkSplitUnits,
    stockDaysBulkSplitPercentage,
    ...rest
  } = data;

  if (rest.stockType !== STOCK_TYPES.LIMITED) return rest;

  const { mode, days, dateRange, dailyDefaults, renewDaily, overrides } =
    stockAvailability ?? {};

  if (mode === STOCK_AVAILABILITY_MODES.PER_DAY) {
    return {
      ...rest,
      stockAvailability: { mode, days: (days ?? []).map(cleanStockDay) },
    };
  }

  return {
    ...rest,
    stockAvailability: {
      dateRange,
      dailyDefaults,
      renewDaily,
      ...(renewDaily && { overrides }),
    },
  };
};
